/**
 * 用户反馈。
 *
 * 差评是最有价值的排障入口：从一条踩直接跳到会话原文与中枢决策，
 * 能回答「她当时为什么这么答」。
 */

import { Segmented, Space, Typography } from "antd";
import { Link, useLocation } from "react-router-dom";
import { DataTable, useTableParams } from "../../components/DataTable";
import { useCharacterScope } from "../../services/character";
import { RelativeTime, StatusTag, Tags } from "../../components/format";
import { ConversationTabs } from "./ConversationsPage";

const FILTERS = ["rating"];

interface FeedbackRow {
  id: string;
  rating: number | null;
  tags: string[];
  comment: string | null;
  messageId: string;
  conversationId: string;
  sequence: number;
  role: string;
  formKey: string | null;
  isFallback: boolean;
  text: string | null;
  userId: string;
  userName: string | null;
  createdAt: string | null;
}

export function FeedbackPage() {
  const scope = useCharacterScope();
  const { searchParams, setParam } = useTableParams(FILTERS);
  const location = useLocation();

  return (
    <>
      <ConversationTabs active={location.pathname} />
      <DataTable<FeedbackRow>
        path="/api/v1/admin/feedback"
        fixedParams={scope}
        filterKeys={FILTERS}
        toolbar={
          <Space>
            <Segmented
              value={searchParams.get("rating") ?? "all"}
              onChange={(v) => setParam("rating", v === "all" ? undefined : String(v))}
              options={[
                { value: "all", label: "全部" },
                { value: "-1", label: "踩" },
                { value: "1", label: "赞" },
              ]}
            />
          </Space>
        }
        columns={[
          {
            title: "评价",
            dataIndex: "rating",
            width: 80,
            render: (v: number | null) =>
              v === 1 ? (
                <Typography.Text style={{ color: "#2F7A4B" }}>赞</Typography.Text>
              ) : v === -1 ? (
                <Typography.Text style={{ color: "#B4232E" }}>踩</Typography.Text>
              ) : (
                "—"
              ),
          },
          {
            title: "用户",
            dataIndex: "userName",
            width: 130,
            render: (v: string | null, r) => <Link to={`/users/${r.userId}`}>{v || "(未命名)"}</Link>,
          },
          { title: "被评价的回复", dataIndex: "text", render: (v) => v || "—" },
          { title: "形态", dataIndex: "formKey", width: 100, render: (v) => <StatusTag value={v} /> },
          {
            title: "兜底",
            dataIndex: "isFallback",
            width: 70,
            render: (v: boolean) => (v ? <Typography.Text type="danger">是</Typography.Text> : "否"),
          },
          { title: "标签", dataIndex: "tags", width: 160, render: (v: string[]) => <Tags values={v} /> },
          { title: "留言", dataIndex: "comment", width: 200, render: (v) => v || "—" },
          {
            title: "会话",
            dataIndex: "conversationId",
            width: 100,
            render: (v: string) => <Link to={`/conversations/${v}`}>{v.slice(-8)}</Link>,
          },
          { title: "时间", dataIndex: "createdAt", width: 130, render: (v) => <RelativeTime value={v} /> },
        ]}
      />
    </>
  );
}
